var b = Object.defineProperty, H = Object.defineProperties;
var N = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var h = (e, i, t) => i in e ? b(e, i, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[i] = t, l = (e, i) => {
  for (var t in i || (i = {}))
    f.call(i, t) && h(e, t, i[t]);
  if (o)
    for (var t of o(i))
      c.call(i, t) && h(e, t, i[t]);
  return e;
}, g = (e, i) => H(e, N(i));
var p = (e, i) => {
  var t = {};
  for (var n in e)
    f.call(e, n) && i.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && o)
    for (var n of o(e))
      i.indexOf(n) < 0 && c.call(e, n) && (t[n] = e[n]);
  return t;
};
import { jsx as j } from "react/jsx-runtime";
import "react";
import { c as B } from "./create-vars-resolver-Bzbn9G-G.js";
import { j as P, b as R, B as V } from "./factory-BnRIVbT0.js";
import { u as _ } from "./use-styles-CB9_o8RJ.js";
import { r as k } from "./rem-CMQJ_ZTp.js";
const q = ["h1", "h2", "h3", "h4", "h5", "h6"], A = ["xs", "sm", "md", "lg", "xl"];
function C(e, i) {
  const t = i !== void 0 ? i : `h${e}`;
  return q.includes(t) ? {
    fontSize: `var(--mantine-${t}-font-size)`,
    fontWeight: `var(--mantine-${t}-font-weight)`,
    lineHeight: `var(--mantine-${t}-line-height)`
  } : A.includes(t) ? {
    fontSize: `var(--mantine-font-size-${t})`,
    fontWeight: `var(--mantine-h${e}-font-weight)`,
    lineHeight: `var(--mantine-h${e}-line-height)`
  } : {
    fontSize: k(t),
    fontWeight: `var(--mantine-h${e}-font-weight)`,
    lineHeight: `var(--mantine-h${e}-line-height)`
  };
}
var u = { root: "m_8a5d1357" };
const D = {
  order: 1
}, E = B((e, { order: i, size: t, lineClamp: n, textWrap: r }) => {
  const s = C(i, t);
  return {
    root: {
      "--title-fw": s.fontWeight,
      "--title-lh": s.lineHeight,
      "--title-fz": s.fontSize,
      "--title-line-clamp": typeof n == "number" ? n.toString() : void 0,
      "--title-text-wrap": r
    }
  };
}), v = P((e, i) => {
  const t = R("Title", D, e), m = t, {
    classNames: n,
    className: r,
    style: s,
    styles: d,
    unstyled: z,
    order: a,
    vars: $,
    size: y,
    variant: S,
    lineClamp: x,
    textWrap: F,
    mod: T
  } = m, w = p(m, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "order",
    "vars",
    "size",
    "variant",
    "lineClamp",
    "textWrap",
    "mod"
  ]), W = _({
    name: "Title",
    props: t,
    classes: u,
    className: r,
    style: s,
    classNames: n,
    styles: d,
    unstyled: z,
    vars: $,
    varsResolver: E
  });
  return [1, 2, 3, 4, 5, 6].includes(a) ? /* @__PURE__ */ j(
    V,
    l(g(l({}, W("root")), {
      component: `h${a}`,
      variant: S,
      ref: i,
      mod: [{ order: a, "data-line-clamp": typeof x == "number" }, T],
      size: y
    }), w)
  ) : null;
});
v.classes = u;
v.displayName = "@mantine/core/Title";
export {
  v as T
};
